import clsx from "clsx";
import React from "react";
import { Button } from "./button/button";

import { BackspaceIcon } from "./icons";

type Props = {
	handleKeyPress: (digit: string) => void;
	handleBackspace: () => void;
	handleReset: () => void;
	className?: string;
};

const PhoneKeyboardBox: React.FC<Props> = ({
	handleKeyPress,
	handleBackspace,
	handleReset,
	className = "",
}) => {
	return (
		<div
			className={clsx(
				"flex flex-col items-center justify-center w-full",
				className,
			)}
		>
			{/* Number pad */}
			<div className="grid w-full max-w-xs grid-cols-3 gap-0">
				{["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"].map((n) => (
					<Button
						variant="keypad"
						key={n}
						className="py-2 items-center justify-center text-lg font-semibold"
						onClick={() => handleKeyPress(n)}
					>
						{n}
					</Button>
				))}
				<div className="col-span-1" />
				<Button
					variant="keypad"
					className="flex items-center justify-center w-full aspect-video [&_svg]:size-5"
					onClick={handleBackspace}
				>
					<BackspaceIcon className="w-5 h-5 fill-primary-600" />{" "}
				</Button>
			</div>

			{/* Reset */}
			<Button
				variant="keypad"
				className="text-sm font-bold cursor-pointer text-textDark py-0"
				onClick={handleReset}
			>
				Reset
			</Button>
		</div>
	);
};

export default PhoneKeyboardBox;
